<div class="row">
  <div *ngFor="let barConfig of stackedBarConfig" class="col">
    <div>{{barConfig.title}}</div>
    <app-stacked-bar [stackedBarConfig]="barConfig" [height]="height" [width]="width / stackedBarConfig?.length - 20"></app-stacked-bar>
  </div>
</div>
